"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageErrorLoad = void 0;
var react_1 = __importStar(require("react"));
var AppContext_1 = __importDefault(require("../../AppProvider/AppContext"));
var PageListingError_style_1 = __importDefault(require("./PageListingError.style"));
exports.PageErrorLoad = function (_a) {
    var image = _a.image, _b = _a.nonFullscreen, nonFullscreen = _b === void 0 ? false : _b, retry = _a.retry;
    var imagePageError = react_1.useContext(AppContext_1.default).imagePageError;
    return (react_1.default.createElement(PageListingError_style_1.default, { "data-cy": "error-load", nonFullscreen: nonFullscreen },
        react_1.default.createElement("div", { className: "connection-lost", "data-key": "error-load" },
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("img", { src: image !== null && image !== void 0 ? image : imagePageError, alt: "" }),
                react_1.default.createElement("h1", null, "Ops..."),
                react_1.default.createElement("h4", null,
                    "Houve um erro ao conectar com o ",
                    react_1.default.createElement("b", null, "Servidor"),
                    ".",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    "Verifique sua internet e tente novamente."),
                react_1.default.createElement("button", { className: "retry-btn", "data-cy": "retry-btn", "data-testid": "retry-btn", onClick: retry, type: "button" }, "Tentar novamente")))));
};
//# sourceMappingURL=PageListingError.js.map